import { FormControl, MenuItem, Select } from "@mui/material";

import { OutcomeType } from "@interfaces/campaign.type";

interface IOutcomeCellProperties {
  handleOutcomeChange: (id: number, newValue: OutcomeType) => Promise<void>;
  id: number;
  isDisabled: boolean;
  outcome: null | OutcomeType;
}

const reverseOutcomeMapping: { [key in OutcomeType]: string } = {
  CDA_NDA_SENT: "CDA/NDA Sent",
  FOLLOW_UP: "Follow Up",
  MEETING_BOOKED: "Meeting Booked",
  NO_INTEREST: "No Interest",
  NO_OUTCOME: "NO_OUTCOME",
  SENT_INFORMATION: "Sent Information",
};

const outcomes = Object.keys(reverseOutcomeMapping) as OutcomeType[];

const OutcomeCell = ({ handleOutcomeChange, id, isDisabled, outcome }: IOutcomeCellProperties) => {
  return (
    <FormControl fullWidth variant="outlined">
      <Select
        disabled={isDisabled}
        onChange={(event) => handleOutcomeChange(id, event.target.value as OutcomeType)}
        sx={{
          ".MuiSelect-select": {
            alignItems: "center",
            display: "flex",
          },
          borderRadius: 2,
          fontSize: 12,
          height: 40,
        }}
        value={outcome}
      >
        <MenuItem disabled value="">
          Select an outcome
        </MenuItem>
        {outcomes
          .filter((o) => o !== "NO_OUTCOME")
          .map((option) => (
            <MenuItem key={option} sx={{ fontSize: 12 }} value={option}>
              {reverseOutcomeMapping[option]}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default OutcomeCell;
